module.exports = __webpack_public_path__ + "img/code.3120b69.png";